<template>
  <div>
    <div v-if="!loading && insightOverallData.length">
      <apexcharts :options="issuesOptions" :series="issuesCount"></apexcharts>
    </div>
    <div v-else-if="!loading && !insightOverallData.length">
      <p>No data available</p>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'InsightOverall',
  components: {
    apexcharts: VueApexCharts
  },
  props: ['brandId', 'insightOverallData'],
  data: function () {
    return {
      issuesCount: [],
      loading: true,
      issuesOptions: {
        chart: {
          title: {
            text: 'Survey Answers Summary'
          },
          type: 'pie'
        },
        labels: []
      }
    }
  },
  watch: {
    insightOverallData (newData) {
      if (newData) {
        this.updateChartData(newData)
      }
    }
  },
  methods: {
    updateChartData (newData) {
      if (newData.length) {
        const labels = newData.map(item => item.answer_option)
        const series = newData.map(item => item.answer_count)
        this.issuesOptions = {
          ...this.issuesOptions,
          labels: labels
        }
        this.issuesCount = series
      }
      this.loading = false
    }
  }
}
</script>
